import React from 'react';
import { Field, useForm, useField } from 'react-final-form';
import omit from 'lodash/omit';

import WpButton from 'Wpds/components/button/WpButton';
import FormInput from 'Shared/components/FormComponents/FormInput';
import { validEmailOrEmptyRequired, useValidator, nonEmptyStringRequired } from 'Shared/utils/formValidations';

import { generateEmptyWorkspace } from '../../../../../DesktopOnboardingWizard/Workspaces/utils';

type Props = {
  onClose(): void;
};

function FormFields({ onClose }: Props) {
  const emailValidate = useValidator(validEmailOrEmptyRequired, 'Invalid Email');
  const nameValidate = useValidator(nonEmptyStringRequired, 'This field is required');
  const {
    input: { value: workspaceToCreateOrUpdate },
    meta: { valid },
  } = useField('workspaceToCreateOrUpdate');
  const { mutators: formMutators } = useForm();

  const isUpdateWorkspace = workspaceToCreateOrUpdate?.uuid;
  const errorsExist = !workspaceToCreateOrUpdate?.fullName || !valid;

  const handleSubmitClick = () => {
    if (!isUpdateWorkspace)
      formMutators.push('workspaces', { ...generateEmptyWorkspace(), ...workspaceToCreateOrUpdate, selected: true });
    else formMutators.update('workspaces', workspaceToCreateOrUpdate.index, omit(workspaceToCreateOrUpdate, ['index']));
    onClose();
  };

  const handleRemoveClick = () => {
    formMutators.remove('workspaces', workspaceToCreateOrUpdate.index);
    onClose();
  };

  return (
    <>
      <div className="AddOrUpdateWorkspaceForm__title">{isUpdateWorkspace ? 'Edit Workspace' : 'Add Workspace'}</div>
      <div className="mt-3 mb-2">
        <Field
          name="workspaceToCreateOrUpdate.fullName"
          placeholder="Full Name"
          validate={nameValidate}
          label="Teammate Name"
          autoComplete="off"
          className="mt-2 mb-1"
          component={FormInput}
          labelMuted
        />
      </div>

      <Field
        name="workspaceToCreateOrUpdate.teammateEmail"
        placeholder="Email"
        validate={emailValidate}
        label="Email (optional)"
        component={FormInput}
        autoComplete="off"
        labelMuted
      />
      <div className="py-2 mt-3">
        <WpButton onClick={handleSubmitClick} block disabled={errorsExist}>
          Save
        </WpButton>
      </div>

      {isUpdateWorkspace && (
        <div className="my-2">
          <WpButton onClick={handleRemoveClick} variant="secondary" block>
            Remove
          </WpButton>
        </div>
      )}

      <WpButton block variant="tertiary" onClick={onClose}>
        Cancel
      </WpButton>
    </>
  );
}

export default FormFields;
